import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    FaYoutube,
    FaWhatsapp,
    FaInstagram,
    FaXTwitter,
    FaFacebook
} from "react-icons/fa6";

// ✅ Logo path
const siteLogo = `${process.env.PUBLIC_URL}/img/Logo.png`;

const Footer = () => {
    return (
        <footer
            style={{
                backgroundColor: "#ffffff",
                color: "#222",
                borderTop: "1px solid #eaeaea",
                marginTop: "40px",
                paddingTop: "40px",
                paddingBottom: "20px",
            }}
        >
            <Container>
                <Row>
                    {/* About Section */}
                    <Col md={4} className="mb-4">
                        {/* Logo */}
                        <img
                            src={siteLogo}
                            alt="Logo"
                            style={{ height: "60px", marginBottom: "10px" }}
                        />

                        <p style={{ color: "#444" }}>
                            Your trusted source for latest news, politics,
                            business, technology, sports and entertainment
                            updates worldwide.
                        </p>
                    </Col>

                    {/* Quick Links */}
                    <Col md={2} className="mb-4">
                        <h6 style={{ fontWeight: "bold", color: "#000" }}>
                            Quick Links
                        </h6>
                        <ul className="list-unstyled">
                            <li>
                                <Link to="/" style={{ color: "#222", textDecoration: "none" }}>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/politics" style={{ color: "#222", textDecoration: "none" }}>
                                    Politics
                                </Link>
                            </li>
                            <li>
                                <Link to="/business" style={{ color: "#222", textDecoration: "none" }}>
                                    Business
                                </Link>
                            </li>
                            <li>
                                <Link to="/technology" style={{ color: "#222", textDecoration: "none" }}>
                                    Technology
                                </Link>
                            </li>
                        </ul>
                    </Col>

                    {/* Categories */}
                    <Col md={3} className="mb-4">
                        <h6 style={{ fontWeight: "bold", color: "#000" }}>
                            Categories
                        </h6>
                        <ul className="list-unstyled">
                            <li>
                                <Link to="/sports" style={{ color: "#222", textDecoration: "none" }}>
                                    Sports
                                </Link>
                            </li>
                            <li>
                                <Link to="/entertainment" style={{ color: "#222", textDecoration: "none" }}>
                                    Entertainment
                                </Link>
                            </li>
                            <li>
                                <Link to="/health" style={{ color: "#222", textDecoration: "none" }}>
                                    Health
                                </Link>
                            </li>
                        </ul>
                    </Col>

                    {/* Social Media */}
                    <Col md={3} className="mb-4">
                        <h6 style={{ fontWeight: "bold", color: "#000" }}>
                            Follow Us
                        </h6>

                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

                            <a
                                href="https://www.youtube.com/@PROUDTAPINEWS"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#222", textDecoration: "none" }}
                            >
                                <FaYoutube style={{ color: "red", marginRight: "8px" }} />
                                YouTube
                            </a>

                            <a
                                href="https://chat.whatsapp.com/HTBbi8H4L222bFEFI368kK?mode=gi_t"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#222", textDecoration: "none" }}
                            >
                                <FaWhatsapp style={{ color: "green", marginRight: "8px" }} />
                                WhatsApp Group
                            </a>

                            <a
                                href="https://www.instagram.com/proud_tapi_news"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#222", textDecoration: "none" }}
                            >
                                <FaInstagram style={{ color: "#E1306C", marginRight: "8px" }} />
                                Instagram
                            </a>

                            <a
                                href="https://x.com/ProudTapi"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#222", textDecoration: "none" }}
                            >
                                <FaXTwitter style={{ color: "#000", marginRight: "8px" }} />
                                X (Twitter)
                            </a>

                            <a
                                href="https://www.facebook.com/share/1CfZwrWSsH/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#222", textDecoration: "none" }}
                            >
                                <FaFacebook style={{ color: "#1877F2", marginRight: "8px" }} />
                                Facebook
                            </a>

                        </div>
                    </Col>
                </Row>

                <hr style={{ borderColor: "#ddd" }} />

                <div style={{ textAlign: "center" }}>
                    <small style={{ color: "#555" }}>
                        © {new Date().getFullYear()} ProudTapi. All Rights Reserved.
                        <br />
                        This Website Follows The Dreamit Infotech Pvt. Ltd.
                    </small>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;